import React from 'react';
import { Link } from 'react-router-dom';
import { Phone, Mail, MapPin, Facebook, Twitter, Linkedin, Instagram } from 'lucide-react';
import { Logo } from './Logo';

export const Footer = () => {
  return (
    <footer className="bg-gradient-to-br from-gray-900 via-black to-gray-900 text-gray-300">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Company Info */}
          <div className="space-y-4">
            <div className="flex items-center space-x-3">
              <Logo size="default" darkMode={true} />
              <span className="font-bold text-white text-lg tracking-tight">UNIVERSA SURGICAL</span>
            </div>
            <p className="text-sm text-gray-400 font-light leading-relaxed">
              Leading manufacturer, importer, and exporter of premium surgical instruments worldwide.
            </p>
            <div className="flex space-x-4">
              <a href="#" className="hover:text-red-400 transition-colors">
                <Facebook className="w-5 h-5" />
              </a>
              <a href="#" className="hover:text-red-400 transition-colors">
                <Twitter className="w-5 h-5" />
              </a>
              <a href="#" className="hover:text-red-400 transition-colors">
                <Linkedin className="w-5 h-5" />
              </a>
              <a href="#" className="hover:text-red-400 transition-colors">
                <Instagram className="w-5 h-5" />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="font-semibold text-white mb-4 tracking-tight">Quick Links</h3>
            <ul className="space-y-2 text-sm">
              <li>
                <Link to="/" className="hover:text-white transition-colors font-light">
                  Home
                </Link>
              </li>
              <li>
                <Link to="/products" className="hover:text-white transition-colors font-light">
                  Products
                </Link>
              </li>
              <li>
                <Link to="/catalogs" className="hover:text-white transition-colors font-light">
                  Catalogs
                </Link>
              </li>
              <li>
                <Link to="/about" className="hover:text-white transition-colors font-light">
                  About Us
                </Link>
              </li>
              <li>
                <Link to="/contact" className="hover:text-white transition-colors font-light">
                  Contact
                </Link>
              </li>
            </ul>
          </div>

          {/* Product Categories */}
          <div>
            <h3 className="font-semibold text-white mb-4 tracking-tight">Categories</h3>
            <ul className="space-y-2 text-sm">
              <li>
                <Link to="/products?category=general-surgery" className="hover:text-white transition-colors font-light">
                  General Surgery
                </Link>
              </li>
              <li>
                <Link to="/products?category=orthopedic" className="hover:text-white transition-colors font-light">
                  Orthopedic
                </Link>
              </li>
              <li>
                <Link to="/products?category=cardiovascular" className="hover:text-white transition-colors font-light">
                  Cardiovascular
                </Link>
              </li>
              <li>
                <Link to="/products?category=ent" className="hover:text-white transition-colors font-light">
                  ENT Instruments
                </Link>
              </li>
              <li>
                <Link to="/products?category=laparoscopic" className="hover:text-white transition-colors font-light">
                  Laparoscopic
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="font-semibold text-white mb-4 tracking-tight">Contact Us</h3>
            <div className="space-y-4 text-sm font-light">
              {/* Pakistan Office */}
              <div>
                <div className="font-semibold text-white mb-2">Pakistan Office</div>
                <div className="flex items-start space-x-2 mb-1">
                  <MapPin className="w-4 h-4 mt-1 flex-shrink-0" />
                  <span>Daska Road, Sialkot, Punjab, Pakistan</span>
                </div>
                <div className="flex items-center space-x-2 ml-6">
                  <Phone className="w-4 h-4 flex-shrink-0" />
                  <a href="tel:+923342744344" className="hover:text-white transition-colors">
                    +92 334 2744344
                  </a>
                </div>
              </div>
              
              {/* Canada Office */}
              <div>
                <div className="font-semibold text-white mb-2">Canada Office</div>
                <div className="flex items-start space-x-2 mb-1">
                  <MapPin className="w-4 h-4 mt-1 flex-shrink-0" />
                  <span>12040 95 St NW, Edmonton, AB, Canada</span>
                </div>
                <div className="flex items-center space-x-2 ml-6">
                  <Phone className="w-4 h-4 flex-shrink-0" />
                  <a href="tel:+15877090167" className="hover:text-white transition-colors">
                    +1-587-709-0167
                  </a>
                </div>
              </div>
              
              <div className="flex items-center space-x-2 pt-2">
                <Mail className="w-4 h-4 flex-shrink-0" />
                <div className="flex flex-col gap-1">
                  <a href="mailto:info@univsurgical.com" className="hover:text-white transition-colors">
                    info@univsurgical.com
                  </a>
                  <a href="mailto:sharjeel@univsurgical.com" className="hover:text-white transition-colors">
                    sharjeel@univsurgical.com
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Bottom bar */}
        <div className="border-t border-gray-800 mt-8 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0 text-sm font-light">
            <p className="text-gray-400">&copy; 2025 Universa Surgical. All rights reserved.</p>
            <div className="flex space-x-6">
              <Link to="#" className="hover:text-white transition-colors text-gray-400">
                Privacy Policy
              </Link>
              <Link to="#" className="hover:text-white transition-colors text-gray-400">
                Terms of Service
              </Link>
              <Link to="#" className="hover:text-white transition-colors text-gray-400">
                Quality Certifications
              </Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};
